<bwh-lib-step-control-bar
  [langDropdown]="true"
  [prevBut]="prevBut"
  [closeBut]="closeBut"
  [currentStep]="wizardService?.currentStep"
  [previousStep]="wizardService?.previousStep"
  [steps]="wizardService?.totalSteps"
  (emitPrev)="goPrev()"
></bwh-lib-step-control-bar>
<div class="text-center step-wrapper">
  <div class="main-header">
    <h1 class="main-title">{{ 'global.education_level_selection_title' | translate }}</h1>
  </div>
  <div>
    <lib-single-select-search
      *ngIf="dataLoaded"
      [options]="educationLevelOptions"
      [control]="educationLevelControl"
      [placeholder]="'work_preferences.select_placeholder' | translate"
      [myFloatLabel]="'never'"
      [forceControl]="true"
      [setControlValue]="true"
      [forceControlByOptions]="true"
      [disabledTyping]="true"
      [disableSearchOptionFiltering]="true"
      [waitForOptionsChange]="true"
      [iconPath]="'/icons/icon-arrow-b-'"
      (changed)="onEducationLevelSelected($event)"
    ></lib-single-select-search>
    <ul class="next-button-container">
      <li *ngIf="prevBut === true">
        <button class="btn w-md h-lg primary prev-btn" type="button" (click)="goPrev()">
          {{ 'global.previous' | translate }}
        </button>
      </li>
      <li>
        <button class="btn w-md h-lg secondary" type="button" (click)="onSubmit()">
          {{ 'global.next_button' | translate }}
        </button>
      </li>
    </ul>
  </div>
</div>
